export { v4 as uuid } from 'uuid';
//# sourceMappingURL=uuid.js.map